import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import HeadlineReveal from "@yumgmbh/gatsby-theme-yum-components/src/components/reveals/HeadlineReveal"

const QuoteBlock = ({ block }) => {
  return (
    <>
      {block.quote && block.quote.length > 0 && (
        <BlockWrapper
          block={block}
          blockWidth="content"
          blockPadding="py-block"
          className="bg-gray-100"
        >
          <blockquote className="text-center ">
            {block.quote_title?.length > 0 && (
              <span className="block text-sm mb-2 text-center uppercase text-primary">
                {block.quote_title}
              </span>
            )}
            <p className={`block text-xl text-black font-semibold`}>
              <span>„</span>
              {block.quote}
              <span>”</span>
            </p>
            {block.author?.length > 0 && (
              <footer className="mt-4">
                {block.image && (
                  <div className="w-16 h-16 mx-auto overflow-hidden rounded-full">
                    <Image
                      className="object-contain w-full h-full"
                      aspectRatio="1by1"
                      image={block.image}
                    />
                  </div>
                )}
                <span className="block font-semibold text-black">
                  {block.author}
                </span>
                {block.author_description?.length > 0 && (
                  <>
                    <span className="block text-sm text-gray-500">
                      {block.author_description}
                    </span>
                  </>
                )}
              </footer>
            )}
          </blockquote>
        </BlockWrapper>
      )}
    </>
  )
}

export default QuoteBlock
